import { Component, OnInit } from '@angular/core';
import { HttpserviceService } from '../../../service/http.service.service';
import { Router } from '@angular/router';
import { UtilsService } from '../../../service/utils.service';
import { GlobalConfig } from '../../../entities/global-config';
import { BsModalRef } from 'ngx-bootstrap';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { debug } from 'util';
import { forEach } from '@angular/router/src/utils/collection';
//import { CKEditorModule } from 'ckeditor4-angular';
declare var initEditor: any;
declare var setDatatoEditor: any;
declare var initEditorBrochure: any;
declare var setDatatoEditorBrochure: any;

@Component({
  selector: 'app-set-project',
  templateUrl: './set-project.component.html',
  styleUrls: ['./set-project.component.css']
})
export class SetProjectComponent implements OnInit {
  projectId: any = '';
  src: any = '';
  apiUrl: any = '';
  propertyForm: FormGroup;
  formErrors: any;
  submitted: Boolean = false;
  isEdit: Boolean = false;
  country: any[] = [];
  state: any[] = [];
  city: any[] = [];
  areas: any[] = [];
  district: any[] = [];
  subArea: any[] = [];
  subSubArea: any[] = [];
  categories: any[] = [];
  facilities: any[] = [];
  facility: any[] = [];
  agents: any[] = [];
  noOfBathrooms: any[] = [];
  payments: any[] = [];
  deliveryDates: any[] = [];

  projects: any = {
    countryId: 1,
    stateId: 1,
    cityId: 2,
    districtId: 1,
    areaId: '',
    userId: '',
    subAreaId: '',
    subSubAreaId: '',
    propertyRefNo: '',
    propertyType: '',
    listingAgent: '',
    listingAgentEmail: '',
    listingAgentPhone: '',
    unitReferenceNo: '',
    rentType: '',
    furnishing: '',
    propertyName: '',
    propertyTitle: '',
    permitNo: '',
    price: '',
    bedrooms: '',
    noOfBathroom: '',
    companyName: '',
    featured: 0,
    facility: [],
    webRemarks: '',
    brochure: '',
    unitBuiltupArea: '',
    images: [],
    brochures: [],
    floorPlans: [],
    longitude: '',
    latitude: '',
    payment: '',
    premiumCount: 0,
    metaTitle: '',
    metaTags: '',
    metaDescription: ''
  };
  subAreaList: any = [];
  subSubAreaList: any = [];
  projectImages: any = { id: '', basc64: '', imageUrl: '', index: -1 };
  projectBrochures: any = { id: '', basc64: '', fileUrl: '', index: -1 };
  projectFloorplans: any = { id: '', basc64: '', fileUrl: '', index: -1, heading: '' };
  constructor(
    private route: ActivatedRoute,
    private servicesComponent: HttpserviceService,
    private router: Router,
    private utilsService: UtilsService,
    private config: GlobalConfig,
    private toastr: ToastsManager
  ) {
    this.projectId = route.snapshot.params['id'];
  }

  agentId: any = '';
  isAgent: Boolean = false;

  ngOnInit() {
    for (var i = 0; i <= 15; i++) {
      this.noOfBathrooms.push(i);
    }
    for (var i = 2019; i <= 2028; i++) {
      for (var j = 1; j <= 4; j++) {
        this.deliveryDates.push('Q' + j + ' ' + i);
      }
    }
    this.deliveryDates.push('Announcing Soon');

    this.projects.propertyRefNo = Math.floor((Math.random() * 100000000) + 1);
    const roles = localStorage.getItem("role");

    this.setPermissions(roles);

    this.apiUrl = this.config.apiRootUrl;
    this.getAreas();
    this.getSubArea();
    this.getSubSubArea();
    this.getCategories();
    this.getFacilities();
    this.GetDevelopers();

    if (this.agentId > 0) {
      this.projects.userId = this.agentId;
    }
    //for (let i = 1; i <= 10; i++) {
    //  this.payments.push({
    //    'instalments': 'Instalments ' + i,
    //    'paymentPercentage': (i + 1) + '0%',
    //    'milestones': 'Milestone ' + i
    //  });
    //}
    new initEditor();
    new initEditorBrochure();
    for (let i = 1; i <= 50; i++) {
      this.payments.push({
        'instalments': '  ',
        'paymentPercentage': '  ',
        'milestones': '  ',
        'planType': 0
      });
    }
    //loadScript("/react/dist/user/watchlist.js");
  }

  //loadScript(src) {
  //  $.getScript(
  //    src, () => console.log('')
  //  ).done((script, textStatus) => {
  //    console.log(textStatus);
  //  }).fail((jqxhr, settings, exception) => {
  //    console.log(exception + ': ' + jqxhr.status);
  //  }
  //  );
  //}

  selection = [];


  // Toggle selection for a given bedroom
  toggleSelection = function toggleSelection(id) {
    var idx = this.selection.indexOf(id);

    // Is currently selected
    if (idx > -1) {
      this.selection.splice(idx, 1);
    }

    // Is newly selected
    else {
      this.selection.push(id);
    }
    this.selection.sort(function (a, b) { return a - b });
    console.log(this.selection);
  };

  categorySelection = [];
  // Toggle selection for a given category
  toggleCategorySelection = function toggleCategorySelection(id) {
    var idx = this.categorySelection.indexOf(id);

    // Is currently selected
    if (idx > -1) {
      this.categorySelection.splice(idx, 1);
    }

    // Is newly selected
    else {
      this.categorySelection.push(id);
    }
    this.categorySelection.sort(function (a, b) { return a - b });
    console.log(this.categorySelection);
  };

  GetDevelopers() {
    this.servicesComponent.GetDevelopers()
      .then((response: any) => {
        if (response.success) {
          this.agents = response.receiveObj;
          if (this.projects.userId > 0) {
            this.projects.companyName = (this.agents.filter(a => Number(a.id) === Number(this.projects.userId)))[0].companyName;
          }

        } else {
          this.toastr.error('Some error occured, Please contact admin.', 'Error!');
        }
      })
      .catch(error => {
        console.log(error);
        this.toastr.error('Some error occured, Please contact admin.', 'Error!');
      });
  }

  toDataURL(url, callback) {
    var xhr = new XMLHttpRequest();
    xhr.onload = function () {
      var reader = new FileReader();
      reader.onloadend = function () {
        callback(reader.result);
      }
      reader.readAsDataURL(xhr.response);
    };
    xhr.open('GET', url);
    xhr.responseType = 'blob';
    xhr.send();
  }

  getProjectDetail(id) {
    this.servicesComponent.getProjectDetail(id)
      .then((response: any) => {
        if (response.success) {
          debugger;
          this.projects = response.receiveObj;
          this.facility = response.receiveObj.facility;
          this.projects.images = response.receiveObj.images;
          this.projects.brochures = response.receiveObj.brochures;
          this.projects.floorPlans = response.receiveObj.floorPlans;
          this.mapFacilitiesId();
          this.subAreaList = this.subArea.filter(a => Number(a.areaId) === Number(this.projects.areaId));
          this.subSubAreaList = this.subSubArea.filter(a => Number(a.subAreaId) === Number(this.projects.subAreaId));
          this.selection = response.receiveObj.bedrooms.split(',').map(Number);
          this.categorySelection = response.receiveObj.projectTypes.split(',').map(Number);
          this.payments.length = 0;

          //for (var i = 0; i < this.projects.floorPlans.length; i++) {
          //  this.toDataURL(this.projects.floorPlans[i].name, function (dataUrl) {
          //    this.projects.floorPlans[i].basc64 = dataUrl;
          //  });            
          //}
          //for (var i = 0; i < this.projects.brochures.length; i++) {
          //  this.toDataURL(this.projects.brochures[i].name, function (dataUrl) {
          //    this.projects.brochures[i].basc64 = dataUrl;
          //  });
          //}
          //for (var i = 0; i < this.projects.images.length; i++) {
          //  this.toDataURL(this.projects.images[i].imageUrl, function (dataUrl) {
          //    this.projects.images[i].basc64 = dataUrl;
          //  });
          //}
          for (var i = 0; i < 50; i++) {
            //debugger;
            if (i < response.receiveObj.payments.length) {
              this.payments.push({
                'instalments': response.receiveObj.payments[i].instalments,
                'paymentPercentage': response.receiveObj.payments[i].paymentPercentage,
                'milestones': response.receiveObj.payments[i].milestones,
                'planType': response.receiveObj.payments[i].planType
              });

              //this.payments[i].instalments = response.receiveObj.payments[i].instalments;
              //this.payments[i].paymentPercentage = response.receiveObj.payments[i].paymentPercentage;
              //this.payments[i].milestones = response.receiveObj.payments[i].milestones;
            } else {
              this.payments.push({
                'instalments': ' ',
                'paymentPercentage': ' ',
                'milestones': ' ',
                'planType': 0
              });

              //this.payments[i].instalments = '  ';
              //this.payments[i].paymentPercentage = ' ';
              //this.payments[i].milestones = '  ';
            }
          }
          setDatatoEditor(response.receiveObj.webRemarks);
          setDatatoEditorBrochure(response.receiveObj.brochure);
        } else {
          this.toastr.error('Some error occured, Please contact admin.', 'Error!');
        }
      })
      .catch(error => {
        console.log(error);
        this.toastr.error('Some error occured, Please contact admin.', 'Error!');
      });
  }

  addProject(form) {
    this.submitted = false;
    if (form.valid) {
      var selectedFacilites = [];
      for (var i = 0; i < this.facilities.length; i++) {
        if (this.facilities[i].facilityValueCheck) {
          selectedFacilites.push(this.facilities[i]);
        }
      }
      this.projects.facility = selectedFacilites;
      //if (this.properties.images.length == 0) {
      //  this.submitted = true;
      //  return 
      //}
      this.projects.payments = this.payments;
      this.projects.bedrooms = this.selection.join(',');

      this.projects.projectTypes = this.categorySelection.join(',');
      this.servicesComponent.saveProject(this.projects)
        .then((response: any) => {
          if (response.receiveObj.success) {
            if (response.receiveObj.result.id === -9999) {
              this.toastr.error('Project Title must be unique., Project title was already taken.', 'Error!');
            } else {
              this.router.navigate(['./project']);
              this.toastr.success('Project add successfully.', 'Success!');
            }
          }
        })
        .catch(error => {
          console.log(error);
          this.toastr.error('Some error occured, Please contact admin.', 'Error!');
        });
    } else {
      this.submitted = true;
    }
  }

  updateProject(form) {
   
    this.submitted = false;
    if (form.valid) {
      var seletedfacility = [];
      for (var i = 0; i < this.facilities.length; i++) {
        if (this.facilities[i].facilityValueCheck) {
          seletedfacility.push(this.facilities[i]);
        }
      }
      var payments = [];

      this.projects.payments = this.payments;
      this.projects.facility = seletedfacility;
      //if (this.properties.images.length == 0) {
      //  this.submitted = true;
      //  return
      //}
      this.projects.webRemarks = (document.getElementById('webRemarks') as HTMLInputElement).value;
      this.projects.brochure = (document.getElementById('brochure') as HTMLInputElement).value;
      this.projects.bedrooms = this.selection.join(',');

      
      this.projects.projectTypes = this.categorySelection.join(',');
      this.servicesComponent.saveProject(this.projects)
        .then((response: any) => {
          if (response.receiveObj.success) {
            if (response.receiveObj.result.id === -9999) {
              this.toastr.error('Project Title must be unique., Project title was already taken.', 'Error!');
            } else {
              this.router.navigate(['./project']);
              this.toastr.success('Project update successfully.', 'Success!');
            }
          }
        })
        .catch(error => {
          console.log(error);
          this.toastr.error('Some error occured, Please contact admin.', 'Error!');
        });
    } else {
      this.submitted = true;
    }
  }

  getState() {
    this.servicesComponent.getState()
      .then((response: any) => {
        if (response.success) {
          this.state = response.receiveObj;
        } else {
          this.toastr.error('Some error occured, Please contact admin.', 'Error!');
        }
      })
      .catch(error => {
        console.log(error);
        this.toastr.error('Some error occured, Please contact admin.', 'Error!');
      });
  }

  getCountry() {
    this.servicesComponent.getCountry()
      .then((response: any) => {
        if (response.success) {
          this.country = response.receiveObj;
        } else {
          this.toastr.error('Some error occured, Please contact admin.', 'Error!');
        }
      })
      .catch(error => {
        console.log(error);
        this.toastr.error('Some error occured, Please contact admin.', 'Error!');
      });
  }

  getCity() {
    this.servicesComponent.getCity()
      .then((response: any) => {
        if (response.success) {
          this.city = response.receiveObj;
        } else {
          this.toastr.error('Some error occured, Please contact admin.', 'Error!');
        }
      })
      .catch(error => {
        console.log(error);
        this.toastr.error('Some error occured, Please contact admin.', 'Error!');
      });
  }

  getAreas() {
    this.servicesComponent.getArea()
      .then((response: any) => {
        if (response.success) {
          this.areas = response.receiveObj;
        } else {
          this.toastr.error('Some error occured, Please contact admin.', 'Error!');
        }
      })
      .catch(error => {
        console.log(error);
        this.toastr.error('Some error occured, Please contact admin.', 'Error!');
      });
  }

  getDistricts() {
    this.servicesComponent.getDistricts()
      .then((response: any) => {
        if (response.success) {
          this.district = response.receiveObj;
        } else {
          this.toastr.error('Some error occured, Please contact admin.', 'Error!');
        }
      })
      .catch(error => {
        console.log(error);
        this.toastr.error('Some error occured, Please contact admin.', 'Error!');
      });

  }

  getSubArea() {
    this.servicesComponent.getSubArea()
      .then((response: any) => {
        if (response.success) {
          this.subArea = response.receiveObj;
        } else {
          this.toastr.error('Some error occured, Please contact admin.', 'Error!');
        }
      })
      .catch(error => {
        console.log(error);
        this.toastr.error('Some error occured, Please contact admin.', 'Error!');
      });
  }

  getSubSubArea() {

    this.servicesComponent.getSubSubArea()
      .then((response: any) => {
        if (response.success) {
          this.subSubArea = response.receiveObj;
        } else {
          this.toastr.error('Some error occured, Please contact admin.', 'Error!');
        }
      })
      .catch(error => {
        console.log(error);
        this.toastr.error('Some error occured, Please contact admin.', 'Error!');
      });
  }

  getCategories() {
    this.servicesComponent.getCategories()
      .then((response: any) => {
        if (response.success) {
          this.categories = response.receiveObj;
        } else {
          this.toastr.error('Some error occured, Please contact admin.', 'Error!');
        }
      })
      .catch(error => {
        console.log(error);
        this.toastr.error('Some error occured, Please contact admin.', 'Error!');
      });
  }

  getFacilities() {
    this.servicesComponent.getFacilities()
      .then((response: any) => {
        if (response.success) {
          this.facilities = response.receiveObj;
          if (this.projectId > 0) {
            this.isEdit = true;
            this.getProjectDetail(this.projectId);
          }
        } else {
          this.toastr.error('Some error occured, Please contact admin.', 'Error!');
        }
      })
      .catch(error => {
        console.log(error);
        this.toastr.error('Some error occured, Please contact admin.', 'Error!');
      });
  }

  mapFacilitiesId() {
    this.facility.forEach(a => {
      this.facilities.forEach(b => {
        if (a.id === b.id) {
          b.facilityValueCheck = true;
        }
        else if (a.id! === b.id) {
          b.facilityValueCheck = false;
        }
      });
    });
  }

  onFileChange($event) {
    const image: any = new Image();
    const file: File = $event.target.files[0];
    const extension = this.getFileExtension(file.name);
    if (file.size / 1000000 > 1.01) {
      this.toastr.error('File size should be less than 1 MB.\n\n Your file size: ' + file.size / 1000000 + 'MB', 'Error!');
    } else {
      if (extension.toLowerCase() === 'png' || extension.toLowerCase() === 'gif' ||
        extension.toLowerCase() === 'jpg' || extension.toLowerCase() === 'jpeg' || extension.toLowerCase() === 'svg') {
        const myReader: FileReader = new FileReader();
        const that = this;
        myReader.onloadend = function (loadEvent: any) {
          that.projectImages.basc64 = loadEvent.target.result;
          that.projectImages.index = that.projects.images.length;
          that.projects.images.push(that.projectImages);
          that.reInit();
        };
        myReader.readAsDataURL(file);
      } else {
        this.toastr.info('Please select valid file.', 'Info!');
      }
    }
  }

  onBrochureFileChange($event) {
    const image: any = new Image();
    const file: File = $event.target.files[0];
    const extension = this.getFileExtension(file.name);
    if (extension.toLowerCase() === 'pdf') {
      const myReader: FileReader = new FileReader();
      const that = this;
      myReader.onloadend = function (loadEvent: any) {
        that.projectBrochures.basc64 = loadEvent.target.result;
        that.projectBrochures.index = that.projects.brochures.length;
        that.projectBrochures.name = file.name;
        that.projects.brochures.push(that.projectBrochures);
        that.reInit();
      };
      myReader.readAsDataURL(file);
    } else {
      this.toastr.info('Please select valid pdf file.', 'Info!');
    }
  }

  //onVideoChange($event) {
  //  debugger;
  //  const image: any = new Image();
  //  const file: File = $event.target.files[0];
  //  const extension = this.getFileExtension(file.name);
  //  if (file.size / 1000000 > 50.01) {
  //    this.toastr.error('File size should be less than 50 MB.\n\n Your file size: ' + file.size / 1000000 + 'MB', 'Error!');
  //  } else {
  //    if (extension.toLowerCase() === 'mp4' || extension.toLowerCase() === 'avi' ||
  //      extension.toLowerCase() === 'mpeg' || extension.toLowerCase() === 'mov') {
  //      var str = '<form name="form1" method="post" enctype="multipart/form-data" action="https://localhost:44355/api/videouploadfiles">' +
  //                  '<input name="file" type="file" />'+
  //        '</form>';


  //      const myReader: FileReader = new FileReader();
  //      const that = this;
  //      myReader.onloadend = function (loadEvent: any) {
  //        that.projects.payment = loadEvent.target.result;
  //        debugger;
  //        //that.projectFloorplans.index = that.projects.floorPlans.length;
  //        //that.projectFloorplans.name = file.name;
  //        //that.projectFloorplans.heading = (that.projects.floorPlans.length + 1) + ' Bedroom';;
  //        //that.projects.floorPlans.push(that.projectFloorplans);
  //        that.reInit();
  //      };
  //      myReader.readAsDataURL(file);
  //    } else {
  //      this.toastr.info('Valid video files are mp4, avi, mpeg and mov only.', 'Info!');
  //    }
  //  }
  //}

  onFloorPlanFileChange($event) {
    const image: any = new Image();
    const file: File = $event.target.files[0];
    const extension = this.getFileExtension(file.name);
    if (file.size / 1000000 > 30.01) {
      this.toastr.error('File size should be less than 30 MB.\n\n Your file size: ' + file.size / 1000000 + 'MB', 'Error!');
    } else {
      if (extension.toLowerCase() === 'pdf') {
        const myReader: FileReader = new FileReader();
        const that = this;
        myReader.onloadend = function (loadEvent: any) {
          that.projectFloorplans.basc64 = loadEvent.target.result;
          that.projectFloorplans.index = that.projects.floorPlans.length;
          that.projectFloorplans.name = file.name;
          that.projectFloorplans.heading = (that.projects.floorPlans.length + 1) + ' Bedroom';;
          that.projects.floorPlans.push(that.projectFloorplans);
          that.reInit();
        };
        myReader.readAsDataURL(file);
      } else {
        this.toastr.info('Please select valid file.', 'Info!');
      }
    }
  }

  //onFloorPlanHeadingChange($event, i) {
  //  debugger;
  //  const that = this;
  //  that.projects.floorPlans[i].heading = $event.target.value;
  //}

  reInit() {
    this.projectImages = { id: '', basc64: '', imageUrl: '', index: -1 };
    this.projectBrochures = { id: '', basc64: '', fileUrl: '', index: -1 };
    this.projectFloorplans = { id: '', basc64: '', fileUrl: '', index: -1, heading: '' };

  }

  getFileExtension(filename) {
    return (/[.]/.exec(filename)) ? /[^.]+$/.exec(filename)[0] : undefined;
  }

  deleteImage(value, index) {
    this.servicesComponent.deleteProjectImage(value)
      .then((response: any) => {
        if (response.receiveObj == true) {
          this.projects.images.splice(index, 1);
          this.toastr.success('Project image delete successfully.', 'Success!');
        }
      })
      .catch(error => {
        console.log(error);
        this.toastr.error('Some error occured, Please contact admin.', 'Error!');
      });
  }

  deleteImageArray(index) {
    if (this.projects.images.length > 0) {
      this.projects.images.splice(index, 1);
    }
  }

  deleteBrochureArray(index) {
    if (this.projects.brochures.length > 0) {
      this.projects.brochures.splice(index, 1);
    }
  }

  deleteFloorPlanArray(index) {
    if (this.projects.floorPlans.length > 0) {
      this.projects.floorPlans.splice(index, 1);
    }
  }

  setPermissions(roles) {
    const userId = Number(JSON.parse(localStorage.getItem("profile")).nameid);
    const data = this;
    if (roles != null) {
      const roleName = roles.split(",");
      roleName.forEach(function (value) {
        switch (value) {
          case "agents":
            data.agentId = userId;
            data.isAgent = true;
            break;

          default:
            break;
        }

      });
    }
  }

  changeArea(areaId) {
    this.subAreaList = this.subArea.filter(a => Number(a.areaId) === Number(areaId))
  }

  onChangeSubArea(subId) {
    this.projects.propertyName = (this.subArea.filter(a => Number(a.id) === Number(subId)))[0].subarea;
    this.subSubAreaList = this.subSubArea.filter(a => Number(a.subAreaId) === Number(subId));
  }

  onChangeAgent(id) {
    this.projects.companyName = (this.agents.filter(a => Number(a.id) === Number(id)))[0].companyName;
  }
}



// WEBPACK FOOTER //
// D:/Projects/Web/Dubai/DubaisaleV1/cpapi.v1/CPDubaisaleApp/src/app/projectsManagement/project/set-project/set-project.component.ts